// prevent commission button from double click

export function commissionButton() {
    const buttonForCommission = document.querySelector<HTMLElement>(
        "#button-for-commission",
    );
    if (!buttonForCommission) {
        return;
    }

    buttonForCommission.addEventListener("click", () => {
        buttonForCommission.style.display = "none";
    });

    buttonForCommission.addEventListener("dblclick", (event) => {
        event.preventDefault();
    });
}
